namespace $.$$ {

	const { hsla } = $mol_style_func

	$mol_style_define( $shm_dashboard_app_menu, {
		// flex: {
		// 	basis: '20rem',
		// },
		minWidth: '220px',
		'[monitoring_only]': {
			true: {
				width: '20rem',
				maxWidth: '100%',
			},
		},
		// maxWidth: '320px',

		Title: {
			flex: {
				grow: 0
			},
		},

		Head: {
			justify: {
				content: 'flex-start',
			},
			align: {
				items: 'center',
			},
			gap: $mol_gap.space,
		},

		Tools: {
			margin: {
				left: 'auto'
			},
		},

		Agent_toggle: {
			// transform: 'scale(0.5)',
			height: '40px',
			width: '2.5rem',
			Img: {
				width: '2rem',
			},
			Front: {
				height: '34px',
				width: '100%',
				padding: 0,
				transform: 'translateY(-4px)',
			},
		},

		Body_content: {
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
			},
			height: '100%',
			minHeight: 0,
			padding: 0,
		},

		Foot_profile_card: {
			align: {
				items: 'center',
			},
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			// box: {
			// 	shadow: [
			// 		[ 0, 0, 0, '1px', $mol_theme.line ],
			// 		[ 0, '0.25rem', '1rem', 0, hsla( 0, 0, 0, .08 ) ],
			// 	],
			// },
			box: {
				shadow: [
					[ 0, `-0.5rem`, `0.5rem`, `-0.5rem`, hsla( 0, 0, 0, .25 ) ],
					[ 0, `0.5rem`, `0.5rem`, `-0.5rem`, hsla( 0, 0, 0, .25 ) ],
				],
			},
			gap: '0.75rem',
			margin: {
				top: 'auto',
				// left: '-0.75rem',
				// right: '-0.75rem',
				// bottom: '-0.75rem',
			},
			padding: '0.75rem',
		},

		Profile: {
			flex: {
				grow: 1,
			},
			// gap: '0.25rem',
			justify: {
				content: 'center',
			},

			Login: {
				justify: {
					content: 'center',
				},
				flex: {
					grow: 1,
				},
			},
		},

		Foot: {
			flex: {
				direction: 'column',
			},
			gap: '0.5rem',
			padding: {
				left: '1.5rem',
				right: '1.5rem',
				bottom: '1rem',
			},
		},

		App_menu: {
			padding: $mol_gap.block,
			flex: {
				direction: 'column',
				grow: 1,
			},
		},

		App_menu_list: {
			flex: {
				direction: 'column',
			},
		},

		Mentions_link: {
			justifyContent: 'flex-start',
		},

		Wordstat_link: {
			justifyContent: 'flex-start',
		},

		Mention_stats_link: {
			justifyContent: 'flex-start',
		},

		Agent_link: {
			justifyContent: 'flex-start',
		},

		Settings_link: {
			// justifyContent: 'flex-start',
			margin: {
				top: 'auto',
			},
		},

		Docs_link: {
			justifyContent: 'flex-start',
		},
	} )

}
